<template>
  <section class="signup-detail section">
    <div v-if="!teamSignedUp">
      <h1 class="title is-size-4">Let's finish this</h1>
      <b-field label="Team Name">
        <b-input v-model="team.name" required name="team_name" type="text" icon="trophy" placeholder="Team Name"></b-input>
      </b-field>
      <b-field label="Captain's Name">
        <b-input v-model="team.captainsName" required name="name" type="text" icon="user-circle" placeholder="Captain's Name"></b-input>
      </b-field>
      <b-field label="Captain's Email">
        <b-input v-model="team.captainsEmail" required name="email" type="email" icon="envelope" placeholder="Captain's Email"></b-input>
      </b-field>
      <b-field label="Captain's Phone Number">
        <b-input v-model="team.captainsPhoneNumber" required name="phone_number" type="tel" icon="mobile" placeholder="Captain's Phone Number"></b-input>
      </b-field>
      <p style="margin-bottom: 0.75rem;">By signing up, my team and I agree to Sharkey's Volleyball Leagues terms and conditions.</p>
      <div v-if="Object.keys(errors).length > 0" class="content has-background-danger has-text-white">
        <p style="margin-bottom: 0.75rem;">Please address the following matters and then try signing up again.</p>
        <ul style="list-style-type: none;">
          <li v-for="(value, key) in errors" :key="key">
            <span style="font-weight: bold;">{{ key }}: </span> {{value}}
          </li>
        </ul>
      </div>
      <button v-if="!teamSignedUp" type="button" :class="['button', 'is-rounded', 'is-primary', 'is-medium', {'is-loading': signupInProgress}]" @click="signup">Signup</button>
    </div>
  </section>
</template>

<script>
import nestedRouterRetriever from '@/mixins/nestedRouterRetriever.js'

export default {
  name: 'SignupDetail',
  mixins: [nestedRouterRetriever],
  mounted() {
    this.$el.querySelector('input[name="team_name"]').focus();
  },
  computed: {
    isEarlyBird() {
      let earlyBird = moment(this.season.earlyBirdEnd, "YYYY-MM-DD");
      let now = moment();
      return moment.duration(now - earlyBird).days() <= 0;
    }
  },
  methods: {
    signup() {
      let data = {
        "name": this.team.name,
        "captainsName": this.team.captainsName,
        "captainsEmail": this.team.captainsEmail,
        "captainsPhoneNumber": this.team.captainsPhoneNumber,
        "leagueId": this.league.id,
        "siteOrigin": window.location.origin
      };
      let promise = this.axios.post(`${this.$apiRoot}/team-signup/`, data);
      this.signupInProgress = true;
      promise.then(result => {
        this.errors = {};
        this.signupInProgress = false;
        let data = result.data;
        this.team.id = data.id;
        this.team.paymentUuid = data.paymentUuid;
        this.team.captain = data.captain;
        this.team.players = data.players;
        this.team.paypalButtonHtml = data.paypalHtml;
        this.team.isPending = data.isPending;
        // If PayPal redirects back to non refreshed page
        // (probably not possible, but just in case)
        this.league.teams.push(this.team);
        this.paypalButtonHtml = data.paypalHtml;
        this.paypalButtonLoading = false;
        this.teamSignedUp = true;
        this.$router.push({name: "signup-pay", params: { seasonId: this.season.id, leagueId: this.league.id, pendingTeamId: this.team.id}});
      });
      promise.catch(error => {
        this.signupInProgress = false;
        this.errors = error.response.data;
      });
    }
  },
  data() {
    return {
      paypalButtonLoading: true,
      paypalButtonHtml: "",
      signupInProgress: false,
      // Set by signup return
      teamSignedUp: false,
      team: {
        // Set by signup return
        id: 0,
        name: "",
        // Set by signup return
        captain: null,
        captainsName: "",
        captainsEmail: "",
        captainsPhoneNumber: "",
        players: [],
        // Set by signup return
        paymentUuid: null
      },
      // From the server
      errors: {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1.title {
  margin-top: 1.5rem;
}
</style>